import { render } from "./TrailerModal.vue?vue&type=template&id=287f8c3a&ts=true"
import script from "./TrailerModal.vue?vue&type=script&lang=ts"
export * from "./TrailerModal.vue?vue&type=script&lang=ts"

import "./TrailerModal.vue?vue&type=style&index=0&id=287f8c3a&lang=css"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__